import { HStack, Spacer, VStack } from "@/components/Layout";
import {
  FloatingActionButton,
  HistoryItem,
  TableofContentsLeftRail,
} from "@/features/history";
import { createFileRoute } from "@tanstack/react-router";
import useGetDeviceHistories from "./-queries/useGetDeviceHistories";

export const Route = createFileRoute(
  "/_staff/profile/device/$id/_profile/history/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { data } = useGetDeviceHistories({ deviceId: id });

  return (
    <HStack className="h-full p-10 gap-8">
      <nav className="sticky top-0 h-fit w-[240px]">
        <TableofContentsLeftRail
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
          basePath={`/profile/device/${id}/history`}
        />
      </nav>
      <VStack className="w-full relative">
        <FloatingActionButton disabled />
        <Spacer size={24} />
        <HistoryItem
          historiesGroupByValidFrom={data.historiesGroupByValidFrom}
        />
      </VStack>
    </HStack>
  );
}
